import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 21h12V7H6v14zm6-11l4 4h-2v4h-4v-4H8l4-4zm3.5-6l-1-1h-5l-1 1H5v2h14V4z"
}), 'RestoreFromTrashSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/RestoreFromTrashSharp.js
// module id = 5812
// module chunks = 2